import Icon from "@mdi/react";
import { mdiEmail } from "@mdi/js";
import { Link } from "easy-page-router/react";

import { useUser } from "../User";
import { Header } from "../components";

import Footer from "../components/Footer";
import { useHead } from "../services/common";
import { useLang } from "../components/Language";
import Content from "../components/Content";
import List from "../components/List";

type PagesProps = {
    type: "about-us" | "tourist",
    url: string,
}

type Page = {
    type: "content" | "list",
    cs: string,
    pl: string,
    background: string,
}

export const aboutUs: Record<string, Page> = {
    "historie": { type: "content", cs: "Historie", pl: "Historia", background: "historie" },
    "kalendar-akci": { type: "content", cs: "Kalendář akcí", pl: "Kalendarz wydarzeń", background: "kalendar-akci" },
    "vyrocni-zpravy": { type: "content", cs: "Výroční zprávy", pl: "Sprawozdania roczne", background: "zima" },
    "projekty": { type: "list", cs: "Projekty", pl: "Projekty", background: "ovce" },
    "clenske-obce": { type: "list", cs: "Členské obce", pl: "Gminy członkowskie", background: "leto" },
    "zapisy-a-ustanoveni": { type: "list", cs: "Zápisy a usnesení", pl: "Protokoły i uchwały", background: "pole" },
    "fotogalerie": { type: "content", cs: "Fotogalerie", pl: "Galeria zdjęć", background: "leto2" },
    "gdpr": { type: "content", cs: "GPDR", pl: "RODO", background: "kopec" },
}

export const tourist: Record<string, Page> = {
    "o-mikroregionu": { type: "content", cs: "O Mikroregionu", pl: "O Mikroregionie", background: "zima2" },
    "turisticky-zajimave-lokality": { type: "list", cs: "Turisticky zajímavé lokality", pl: "Atrakcje turystyczne", background: "rybnik" },
    "aktivni-zima-na-jilemnicku": { type: "content", cs: "Aktivní zima na Jilemnicku", pl: "Aktywna zima w Jilemnicku", background: "lyze" },
    "aktivni-leto-na-jilemnicku": { type: "content", cs: "Aktivní léto na Jilemnicku", pl: "Aktywne lato w Jilemnicku", background: "leto2" },
    "cykloturistika-na-jilemnicku": { type: "content", cs: "Cykloturistika na Jilemnicku", pl: "Turystyka rowerowa w Jilemnicku", background: "region" },
    "kultura-a-pamate-na-jilemnicku": { type: "content", cs: "Naučné a poznávací stezky", pl: "Ścieżki dydaktyczne i poznawcze", background: "krakonos" },
    "relaxace-na-jilemnicku": { type: "content", cs: "Relaxace na Jilemnicku", pl: "Relaks w Jilemnicku", background: "pampelisky" },
    "jilemnicko-pro-rodiny-s-dětmi": { type: "content", cs: "SmileAtMe", pl: "SmileAtMe", background: "deti" },
}

export default function Pages({ type, url }: PagesProps) {
    const user = useUser();
    const lang = useLang();

    const pages = type === "about-us" ? aboutUs : tourist;
    const page = pages[url] || {
        type: "",
        cs: "404 - stránka nenalezena",
        pl: "404 - nie znaleziono strony",
        background: "o-nas",
    };

    const title = `${lang === "cs" ? page.cs : page.pl}`;
    const titleType = `${lang === "cs" ? (type === "about-us" ? "O nás" : "Turista") : (type === "about-us" ? "O nas" : "Turysta")}`

    useHead(
        `${title} | ${titleType}`,
        `${title} | ${titleType}`, // TODO: by page content
    );

    return (
        <>
            <Header title={title} background={page.background} />

            <main>
                <div className="content-page">
                    <h1 className="hidden">{title} | {titleType}</h1>
                    <div className="content-split">
                        <section className="pages menu">
                            {Object.entries(pages).map(([urlPage, page]) => <Link
                                key={urlPage}
                                to={`/${lang === "pl" ? "pl/" : ""}${type === "about-us" ? "o-nas" : "turista"}/${urlPage}`}
                                className={urlPage === url ? "active" : ""}
                            >
                                {lang === "cs" ? page.cs : page.pl}
                            </Link>)}
                            <div className="service-detail">
                                <div className="mail">
                                    <Icon path={mdiEmail} size={1.5} />
                                </div>
                                <div className="title">
                                    {lang === "cs"
                                        ? <>Potřebujete <br />poradit</>
                                        : <>Potrzebujesz <br />porady</>}
                                </div>
                                <div className="text">
                                    {lang === "cs" ? "Pište na" : "Napisz na adres"}<br />
                                    <a href="mailto:jilemnicko@jilemnicko-so.cz">jilemnicko@jilemnicko-so.cz</a>
                                </div>
                            </div>
                        </section>

                        <section className="grow">
                            {page.type === "content" && <Content id={url} />}
                            {page.type === "list" && <List id={url} />}
                            {!page.type && <p className="alert">404 - stránka nenalezena</p>}
                        </section>
                    </div>
                </div>
            </main>

            <Footer />
        </>
    );
}
